<form [formGroup]="search">
    <div class="form-group">
        <div class="input-group input-group-sm">
            <div class="input-group-append">
                <span class="input-group-text"><span class="mdi mdi-magnify search-icon"></span></span>
            </div>
            <input autocomplete="off" type="search" class="form-control form-control-sm" id="search" autofocus="true" formControlName="inquiry" placeholder="Find an account" />
        </div>
    </div>
    @if (!financeTypeId) {
        <div class="form-group">
            <select class="form-control form-control-sm" name="type" id="type-filter" formControlName="type">
                <option value="0">All account types</option>
                <option value="4">Buy Here - Pay Here</option>
                <option value="3">Outside Financed</option>
                <option value="2">Wholesale</option>
                <option value="1">Cash</option>
            </select>
        </div>
    }
</form>

<ul class="nav nav-tabs">
    <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'active'" (click)="setActiveTab($event, 'active')">Active</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'inactive'" (click)="setActiveTab($event, 'inactive')">Inactive</a>
    </li>
</ul>

<ul id="all-accounts" class="list-group list-group-flush pay-list" (scroll)="scrolled($event)">
    @if ((!accounts || (accounts.length <= 0))) { 
        <li class="list-group-item">No accounts at this time.</li>
    }
    @for (account of accounts; track account.id) {
        <li class="list-group-item" [ngClass]="{'active': (account.termsId == termsId)}" (click)="selected($event, account)">
             @if (!account.url) {
                <span class="material-icons">{{icon(account.category)}}</span>
            }
            @if (account.url) {
                <img [src]="account.url" [alt]="account.vehicle || null" />
            }
            <div class="text-truncate">
                <p class="title">{{account.contact}}</p>
                <p class="subtitle">{{account.stock}} {{account.vehicle}}</p>
            </div>
            <div class="currency d-none d-lg-block">
                @if (account.group && (account.group.toLowerCase() === 'closed')) {
                    <p class="title">{{account.status}}</p>
                    <p class="subtitle">{{account.group.toLowerCase()}}</p>
                }
                @else {
                    <p class="title due {{dueToClass(account.due)}}">{{account.amount | currency}}</p>
                    <p class="subtitle">{{account.categories.join(', ')}}</p>
                }
            </div>
        </li>
    }
</ul>